/**
 * @deprecated
 * 编辑器模式：默认 ｜ 字幕&配音
 */
export enum ProjectMode {
  // 默认
  Default = 'edit',
  // 字幕&配音
  Subtitle = 'combine',
}

export enum ProjectType {
  // 普通视频项目
  Normal = 'normal',
  // 批量导出项目
  Batch = 'batch',
  /** 模版项目，包含公共和人个模版 */
  Template = 'template',
  /** 快速替换项目 */
  Simple = 'simple',
}

export enum ProjectTab {
  // 创意制作
  Creative = 'creative',
  // 多比例裂变
  MultiRatio = 'multi-ratio',
  // 多语言裂变
  MultiLanguage = 'multi-language',
}
